import styled from 'styled-components';

export const Button = styled.button`
  cursor: pointer;
  /* position: absolute;
  top: 0px;
  right: 10px;
  height: 42px;
  width: 42px; */
  background-color: #3fa0f6;
  border: 0;
  padding: 0;
  margin: 0;
  border-radius: 10px;
  width: 90px;
  height: 36px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 25px auto;

  img {
    max-height: 80%;
    width: auto;
  }
  transition: background-color 0.2s ease-in;
  &:hover {
    /* box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.6); */
    background-color: #0f80c6;
  }
`;

export const ButtonCall = styled(Button)`
  background-image: url(/images/calls/call-start.svg);
  background-position-x: 60%;
`;

export const ButtonDrop = styled(Button)`
  background-image: url(/images/calls/call-end.svg);
  background-color: #d14d45;
  &:hover {
    background-color: #a11d15;
  }
`;
